var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M27.471,30.075c-6.516,0-11.816-5.302-11.816-11.816s5.3-11.817,11.816-11.817 c6.515,0,11.816,5.302,11.816,11.816S33.986,30.075,27.471,30.075z M27.471,7.942c-5.688,0-10.316,4.628-10.316,10.316 c0,5.688,4.628,10.316,10.316,10.316s10.316-4.629,10.316-10.316C37.787,12.57,33.159,7.942,27.471,7.942z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M27.471,23.647c-2.971,0-5.387-2.418-5.387-5.389s2.416-5.388,5.387-5.388c2.97,0,5.386,2.417,5.386,5.388 S30.441,23.647,27.471,23.647z M27.471,14.371c-2.144,0-3.887,1.744-3.887,3.888c0,2.145,1.743,3.889,3.887,3.889 s3.886-1.744,3.886-3.889C31.357,16.115,29.613,14.371,27.471,14.371z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "29.967,7.802 29.341,4.237 25.714,4.237 25.209,7.714 23.725,7.498 24.415,2.737 30.602,2.737  31.443,7.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "30.732,33.946 24.548,33.946 23.704,29.143 25.181,28.883 25.808,32.446 29.436,32.446  29.939,28.97 31.424,29.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "16.654,22.12 11.893,21.429 11.893,15.243 16.698,14.4 16.958,15.878 13.393,16.503  13.393,20.132 16.869,20.636  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "38.302,22.116 38.042,20.64 41.607,20.014 41.607,16.388 38.13,15.881 38.348,14.396  43.107,15.09 43.107,21.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "18.581,31.781 14.207,27.408 17.01,23.414 18.238,24.275 16.158,27.238 18.724,29.803 21.54,27.7  22.437,28.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "37.891,13.409 36.662,12.548 38.742,9.585 36.177,7.021 33.359,9.122 32.464,7.92 36.318,5.042  40.693,9.415  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "36.43,31.368 32.436,28.563 33.297,27.337 36.259,29.415 38.823,26.85 36.723,24.033  37.926,23.137 40.802,26.992  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A79D",
    points: "17,13.285 14.123,9.429 18.496,5.056 22.489,7.857 21.628,9.085 18.666,7.007 16.102,9.571  18.203,12.388  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.5f37ec29862307aec5fdb88a2f2a39c2.svg";
export { ForwardRef as ReactComponent };